import React from "react";

/* Two people — roles and members, as against one person's profile. */
export const UsersIcon = ({ size = 16, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
       aria-hidden="true" focusable="false" className={className}>
    <circle cx="9" cy="8" r="3.25" stroke="currentColor" strokeWidth="1.7" />
    <path d="M3.5 19.5a5.5 5.5 0 0111 0"
          stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    <path d="M16.5 5.2a3.25 3.25 0 010 5.6M17.5 14.6a5.5 5.5 0 013 4.9"
          stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
  </svg>
);

export default UsersIcon;
